import React, { Fragment, useRef } from 'react';

const EmbeddedApiDocumentation = () => {
    const windowSize = useRef([window.innerWidth, window.innerHeight]);

    return (
        <Fragment>
            <iframe
                src="https://accessepos.gitbook.io/hospitality-integration-hub?visitor.isEmbedded=true&visitor.product=resdiary"
                title="Gitbook Docs"
                width="100%"
                height={windowSize.current[1] - 56 + 'px'}
            />
        </Fragment>
    );
};

export default EmbeddedApiDocumentation;
